import axios from "axios";
import { authHeader } from "./auth-header";

//Building the complete URL for all the fullrail calls
const buildURL = (url) => {
  //If it is production enviroment change the base url
  return process.env.REACT_APP_SERVER_URL_V1 + url;
};

//Function for building header for fullrail calls
const buildHeaders = (auth, isJsonRequest = true) => {
  let headers = {};
  if(isJsonRequest){
    headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
  }
  else {
    // For FormData / file uploads
    headers = {
      Accept: "application/json", // keep accept header
      // don't add Content-Type, browser will set it with boundary
    };
  }
  if (auth === true) {
    headers = { ...headers, ...authHeader() };
  }
  return headers;
};

//Constant to build reset password headers
const buildResetPasswordHeaders = (auth) => {
  let headers = {
    "Content-Type": "application/json",
  };

  if (auth === true) {
    headers = { ...headers };
  }

  return headers;
};

//Constant to build login headers
const buildLoginHeaders = () => {
  return {
    "Content-Type": "application/x-www-form-urlencoded",
  };
};
//Creating delete request header for calls
const getRequest = (url, auth = true) => {
  const completeUrl = buildURL(url);
  const headers = buildHeaders(auth);
  const requestOptions = {
    method: "GET",
    headers: headers,
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};
//Creating delete request header for calls
const deleteRequest = (url, auth = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "DELETE",
    headers: buildHeaders(auth),
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};
//Creating post request header for calls
const postRequest = (url, dataObj, isJsonRequest = false, auth = true) => {
  const completeUrl = buildURL(url);
  let requestOptions = {
    method: "POST",
    headers: buildHeaders(auth, isJsonRequest),
    data: dataObj,
  };
  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};
//Creating put request header for calls
const putRequest = (url, dataObj, isJsonRequest = false, auth = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(auth, isJsonRequest),
    data: JSON.stringify(dataObj),
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};
//Creating request call for password reset
const resetPasswordPostRequest = (
  url,
  urlBase,
  dataObj,
  isPost,
  auth = true
) => {
  const completeUrl = buildURL(url, urlBase);
  let requestOptions = {};

  requestOptions = {
    method: isPost ? "POST" : "PUT",
    headers: buildResetPasswordHeaders(auth),
    data: dataObj,
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};
//Creating post request header for calls of files
const postRequestFiles = (
  url,
  urlBase,
  dataObj,
  auth = true,
  isJsonRequest = false
) => {
  const completeUrl = buildURL(url, urlBase);

  const requestOptions = {
    method: "POST",
    headers: buildHeaders(auth, urlBase, isJsonRequest),
    data: dataObj,
    responseType: "blob",
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};
//Creating get request header for calls of files
const getRequestFiles = (url, urlBase, auth = true) => {
  const completeUrl = buildURL(url, urlBase);

  const requestOptions = {
    method: "GET",
    headers: buildHeaders(auth, urlBase),
    responseType: "blob",
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};
//Creating post request call for form data
const formDataPostRequest = (url, dataObj, auth = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "POST",
    headers: buildHeaders(auth, false),
    data: dataObj,
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};
//Creating put request call for form data
const formDataPutRequest = (url, dataObj, auth = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(auth, false),
    data: dataObj,
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

export {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  formDataPostRequest,
  formDataPutRequest,
  postRequestFiles,
  getRequestFiles,
  resetPasswordPostRequest,
};
